<template>
  <v-flex>
    <v-layout row class="content-header">
      <v-flex md5 class="content-title">
        <h2>Endossos</h2>
        <h4>Consulte e faça download de endossos.</h4>
      </v-flex>
      <v-flex md3>
        <v-text-field
          v-model="search"
          label="Pesquisa"
          placeholder="Numero da apólice ou endosso"
          outlined
          class="input-pesquisa"
          @keyup.enter="pesquisar()"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        &nbsp;<v-btn color="info" @click="pesquisar()"
          ><v-icon>mdi-magnify</v-icon></v-btn
        >
        &nbsp;&nbsp;<v-btn color="info" @click="requestEndossos()"
          >Listar Endossos Disponíveis</v-btn
        >
      </v-flex>
      <v-flex md12>
        <div class="line"></div>
      </v-flex>
    </v-layout>
    <v-layout row class="content-body overflow-y-auto">
      <v-flex md12>
        <v-data-table
          :headers="headers"
          :items="endossos"
          :items-per-page="topItems"
          :loading="loading"
          :search="search"
          loading-text="Carregando... Por favor aguarde."
          :no-data-text="noDataText"
          no-results-text="Nenhuma informação encontrada"
          :sort-by="['dataEmissao']"
          :sort-desc="[true]"
          class=""
        >
          <template v-slot:item.anexo="{ item }">
            <img
              class="hover"
              src="/img/icon-pdf.png"
              @click="gerarEndosso(item.de)"
            />
          </template>
          <template v-slot:item.dataEmissao="{ item }">
            {{ item.dataEmissao | formatDateBR }}
          </template>

          <template v-slot:item.dataInicioVigencia="{ item }">
            {{ item.dataInicioVigencia | formatDateBR }}
          </template>
          <template v-slot:item.dataFimVigencia="{ item }">
            <span v-if="item.dataFimVigencia == null">N/A</span>
            <span v-if="item.dataFimVigencia != null">{{
              item.dataFimVigencia | formatDateBR
            }}</span>
          </template>
        </v-data-table>
      </v-flex>

      <v-overlay :value="fullLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-layout>
  </v-flex>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import Helpers from "@/utilities/Helpers";

export default {
  data() {
    return {
      search: "",
      baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
      termoPesquisa: "",
      loading: false,
      fullLoading: false,
      topItems: 10,
      options: {},
      headers: [
        { text: "Apólice", value: "numeroApolice", sortable: true },
        {
          text: "Apólice sem ponto",
          value: "numeroApoliceSemPonto",
          sortable: false,
          align: " d-none",
        },
        { text: "Endosso", value: "numeroEndosso", sortable: true },
        {
          text: "Endosso sem ponto",
          value: "numeroEndossoSemPonto",
          sortable: false,
          align: " d-none",
        },
        {
          text: "Estipulante/Segurado",
          value: "nomeEstipulante",
          sortable: true,
        },
        { text: "CNPJ/CPF", value: "cnpjEstipulante", sortable: true },
        { text: "Tipo de Endosso", value: "tipoEndosso", sortable: true },
        { text: "Emissão", value: "dataEmissao", sortable: true },
        {
          text: "Início de Vigência (24h)",
          value: "dataInicioVigencia",
          sortable: true,
        },
        {
          text: "Fim de Vigência (24h)",
          value: "dataFimVigencia",
          sortable: true,
        },
        { text: "Download", value: "anexo", sortable: false },

        //{text: "CNPJ/CPF com ponto", value: "CnpjCpfComPonto", sortable: false, align: ' d-none'},
      ],
      endossos: [],
      noDataText: "Nenhuma informação pesquisada",
    };
  },
  methods: {
    requestEndossos() {
      this.loading = true;
      this.fullLoading = true;
      let codigoCorretor = this.usuario.codCorretor;

      let url = "Endosso/" + codigoCorretor;

      // Se tiver termo para pesquisa
      if (this.search != "") url += "/" + this.search.replace("/", "_");

      // Request apolices
      Vue.prototype.$httpPortal
        .get(url)
        .then((res) => {
          console.log(res.data);
          this.endossos = res.data;
          for (let endosso in this.endossos) {
            this.endossos[endosso].numeroApoliceSemPonto = this.endossos[
              endosso
            ].numeroApolice
              .split(".")
              .join("")
              .split("-")
              .join("");
            this.endossos[endosso].numeroEndossoSemPonto = this.endossos[
              endosso
            ].numeroEndosso
              .split(".")
              .join("")
              .split("-")
              .join("");
          }

          if (res.data.length == 0) {
            this.noDataText = "Nenhuma informação encontrada";
          }
          //this.search = "";
          this.loading = false;
          this.fullLoading = false;
        })
        .catch((ex) => {
          console.log(ex);
          this.noDataText = "Nenhuma informação encontrada";
          this.loading = false;
          this.fullLoading = false;
        });
    },
    pesquisar() {
      this.requestEndossos();
    },
    gerarEndosso(value) {
      //this.fullLoading = true;
      let url = this.baseURL + "Emissao/Endosso/" + value;
      /*
                let link = document.createElement('a');
                link.href = url;
                link.download = "Certificado.pdf";
                link.click(); 

                setTimeout(() => { this.fullLoading = false;}, 10000);
                */
      window.open(url, "_blank");
    },
  },
  computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" }),
  },
  filters: {
    formatDateBR(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
  mounted() {
    //this.requestEndossos()
  },
};
</script>
